import { render, staticRenderFns } from "./ThgCheckoutSustainableCard.vue?vue&type=template&id=30c9c4cc"
import script from "./ThgCheckoutSustainableCard.vue?vue&type=script&lang=ts"
export * from "./ThgCheckoutSustainableCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgCheckoutSustainableCard.vue?vue&type=style&index=0&id=30c9c4cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports